import { call, put } from "redux-saga/effects";
import { apiRouting, notify } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListBoardingConditionsActions } from "store/ducks/boarding_conditions";

import { BoardingConditions } from "interfaces/boarding-conditions";

export function* listBoardingConditionsRequest(action: any) {
  try {
    const { onSuccess } = action as IListRequest;
    const { data } = yield call(apiRouting.get, `/boarding-conditions`);
    const comboOptions = data.map((boardingConditions: BoardingConditions) => ({
      value: boardingConditions.id,
      label: `${boardingConditions.description} - ${boardingConditions.codigo}`,
    }));

    yield put(ListBoardingConditionsActions.success(comboOptions));
    if (onSuccess) onSuccess(comboOptions);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListBoardingConditionsActions.failure(errorMessage));
  }
}
